import React, { useState, useEffect, useCallback } from 'react';
import { Tabs, Row, Col } from 'antd';
import { GlobalOutlined, CodeOutlined } from '@ant-design/icons';
import ManageWebsites from '../Websites/ManageWebsites';
import ManageSnippets from '../Snippets/ManageSnippets';
import WebsiteSnippetHealthCard from '../components/WebsiteSnippetHealthCard';
import { API_BASE, authHeaders } from '../../config/api';
import '../admin.css';

const WebsitesSnippetsPage = () => {
  const [activeTab, setActiveTab] = useState('websites');
  const [websites, setWebsites] = useState([]);
  const [snippets, setSnippets] = useState([]);
  const [loading, setLoading] = useState(true);

  const loadData = useCallback(async () => {
    setLoading(true);
    try {
      const [wRes, sRes] = await Promise.all([
        fetch(`${API_BASE}/my/websites`, { headers: { 'Content-Type': 'application/json', ...authHeaders() } }),
        fetch(`${API_BASE}/my/snippets`, { headers: { 'Content-Type': 'application/json', ...authHeaders() } })
      ]);
      const [wBody, sBody] = await Promise.all([
        wRes.json().catch(() => ({ items: [] })),
        sRes.json().catch(() => ({ items: [] }))
      ]);
      setWebsites(Array.isArray(wBody?.items) ? wBody.items : Array.isArray(wBody) ? wBody : []);
      setSnippets(Array.isArray(sBody?.items) ? sBody.items : Array.isArray(sBody) ? sBody : []);
    } catch {
      setWebsites([]);
      setSnippets([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadData();
  }, [loadData]);

  const items = [
    {
      key: 'websites',
      label: (
        <span>
          <GlobalOutlined />
          Websites
        </span>
      ),
      children: <ManageWebsites />,
    },
    {
      key: 'snippets',
      label: (
        <span>
          <CodeOutlined />
          Snippets
        </span>
      ),
      children: <ManageSnippets />,
    },
  ];

  return (
    <div className="abo-content">
      <Row gutter={[16, 16]} style={{ marginBottom: 24 }}>
        <Col xs={24} lg={10}>
          <WebsiteSnippetHealthCard websites={websites} snippets={snippets} loading={loading} />
        </Col>
      </Row>
      <Tabs
        activeKey={activeTab}
        onChange={setActiveTab}
        items={items}
        size="large"
        style={{ marginBottom: 24 }}
      />
    </div>
  );
};

export default WebsitesSnippetsPage;
